
import React from "react";
import "../src/style/PrivacyPolicy.css";

const PrivacyPolicy = () => {
    return (
        <>
            <nav
                className="breadcrumb"
                style={{
                    backgroundImage: "url('./airplane.avif')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    padding: "55px",
                    color: "white",
                    textAlign: "center",
                    fontSize: "1.5rem",
                    fontWeight: "bold",
                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)"
                }}
            >
                <a href="/" style={{ color: "white", textDecoration: "none", marginRight: "10px" }}>Home</a>
                &gt; <span>Privacy & Policy</span>
            </nav>

            <div className="privacy-container container" style={{ maxWidth: "1000px", margin: "auto", padding: "50px", background: "#fff", borderRadius: "10px", boxShadow: "0 4px 10px rgba(0,0,0,0.1)", marginTop: "30px" }}>
                <h1 className="privacy-title" style={{ textAlign: "left", color: "#007bff", marginBottom: "30px", fontSize: "2rem", fontWeight: "bold" }}>Privacy Policy</h1>
                <p className="privacy-text" style={{ fontSize: "1.2rem", lineHeight: "1.8", color: "#333", textAlign: "left" }}>
                    Welcome to our flight booking website. Your privacy is important to us.
                    This Privacy Policy explains how we collect, use, disclose, and safeguard your information.
                </p>

                {[  
                    { title: "1. Information We Collect", text: "We collect personal information such as your name, email, phone number, and payment details when you book a flight." },
                    { title: "2. How We Use Your Information", text: "We use your information to process bookings, send confirmations, provide customer support, and improve our services." },
                    { title: "3. Data Sharing & Disclosure", text: "We do not sell your personal data. However, we may share it with airline partners, payment processors, and legal authorities when required." },
                    { title: "4. Data Security", text: "We implement industry-standard security measures to protect your data from unauthorized access and breaches." },
                    { title: "5. Cookies & Tracking Technologies", text: "We use cookies to enhance your browsing experience and analyze site traffic." },
                    { title: "6. Your Rights", text: "You have the right to access, update, or delete your personal information by contacting us." },
                    { title: "7. Changes to This Policy", text: "We may update this policy from time to time. Any changes will be posted on this page." },
                    { title: "8. Contact Us", text: "If you have any questions about this Privacy Policy, please contact us at support@example.com." }
                ].map((section, index) => (
                    <div key={index} >
                        <h2 className="privacy-heading" style={{ color: "#007bff", marginBottom: "15px", fontSize: "1.5rem", textAlign: "left", fontWeight: "600" }}>{section.title}</h2>
                        <p className="privacy-text" style={{ fontSize: "1.1rem", lineHeight: "1.8", color: "#555", textAlign: "left", paddingRight: "10px" }}>{section.text}</p>
                    </div>
                ))}
            </div>
        </>
    );
};

export default PrivacyPolicy;